module.exports = __webpack_public_path__ + "static/media/LayerManagement.ba493915.png";